package org.example.site_web.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.toMutableStateMap
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.max
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.dom.svg.Text
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.modifiers.attrs
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.topBottom
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.ArrowUpIcon
import com.varabyte.kobweb.silk.components.icons.CloseIcon
import com.varabyte.kobweb.silk.components.icons.ExpandIcon
import com.varabyte.kobweb.silk.components.icons.MinusIcon
import com.varabyte.kobweb.silk.components.icons.PlusIcon
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.example.site_web.aiPalette
import org.example.site_web.components.images.AccTriangleIcon
import org.example.site_web.components.images.ChevronDown2Icon
import org.example.site_web.components.widgets.AnimatedLogo
import org.example.site_web.content.WorkingTogetherContentMap
import org.example.site_web.content.WorkingTogetherData
import org.example.site_web.content.YourNeedEntry
import org.example.site_web.content.ourOfferContentMap
import org.example.site_web.content.yourNeedsContentMap
import org.jetbrains.compose.web.css.Color.white
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Br
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import kotlin.collections.get
import kotlin.collections.iterator

@Composable
fun WorkingTogetherResp() {
    Column(
        YourNeedsContainerBackgroundStyle.toModifier()
            .fillMaxWidth()
            .padding(bottom = 4.em), horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(
            Modifier.width(min(70.vw, 1344.px))
                .padding {
                    topBottom(1.em)
                }, horizontalAlignment = Alignment.Start,
            verticalArrangement = Arrangement.Top
        ) {

            Span(
                Modifier.fontSize(1.8.cssRem)
                    .fontWeight(FontWeight.SemiBold).toAttrs()
            )
            {
                AccTriangleIcon()
                Text("Travaillons ensemble")
            }
            Span(
                Modifier
                    .fontSize(1.cssRem)
                    .fontWeight(FontWeight.Lighter)
                    .toAttrs()
            ) {
                Text("Des modes de collaboration adaptés à vos besoins.")
            }
            Box(Modifier.width(min(70.vw, 1344.px))) {
                WorkingTogetherLargeLayout(modifier = Modifier.margin(top=1.em).displayIfAtLeast(Breakpoint.LG))
                WorkingTogetherThinLayout(modifier = Modifier.margin(top=1.em).displayUntil(Breakpoint.LG))
            }
        }
    }
}

@Composable
fun WorkingTogetherLargeLayout(modifier: Modifier = Modifier) {
    val entrySelected = mutableStateOf<String>(WorkingTogetherContentMap.firstNotNullOf { entry -> entry.key })
    Column(modifier.fillMaxWidth()) {
        Row(Modifier.fillMaxWidth()) {
            for (entry in WorkingTogetherContentMap) {
                val isSelected = entrySelected.value == entry.key
                WorkingTogetherButton(
                    modifier = Modifier.margin(leftRight = 1.em),
                    entry = entry.value,
                    isSelected = isSelected,
                    onClick = {
                        entrySelected.value = entry.key
                    })
            }
        }
        Row(
            Modifier
                .fillMaxWidth()
                .margin(top = 0.25.cssRem, bottom = 1.5.cssRem)
                .padding(top = 1.cssRem, bottom = 1.cssRem)
                .borderTop{
                    style(LineStyle.Solid)
                    color(aiPalette.mainPalette.darker)
                    width(2.px)
                }
                .borderBottom{
                    style(LineStyle.Solid)
                    color(aiPalette.mainPalette.darker)
                    width(2.px)
                },
            verticalAlignment = Alignment.Top
        )
        {
            WorkingTogetherDescription(
                WorkingTogetherContentMap.get(entrySelected.value) ?: WorkingTogetherData("NULL", "NULL", ""),
                modifier = Modifier
                    .height(10.cssRem)
                    .padding(leftRight = 2.em)
                    .width(60.percent)
            )
            WorkingTogetherImage(entrySelected.value, modifier = Modifier
                .height(10.cssRem)
                .width(40.percent))
        }
    }
}


@Composable
fun WorkingTogetherThinLayout(modifier: Modifier = Modifier) {
    val entrySelected = mutableStateOf<String?>(null)
    Column(
        modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        for (entry in WorkingTogetherContentMap) {
            val isSelected = entrySelected.value == entry.key
            WorkingTogetherButton(
                modifier = Modifier
                    .width(max(50.vh,20.cssRem))
                    .margin(leftRight = 1.em, topBottom = 0.25.em),
                entry = entry.value,
                isSelected = isSelected,
                onClick = {
                    if (entrySelected.value == entry.key) {
                        entrySelected.value = null
                    } else {
                        entrySelected.value = entry.key
                    }
                })
            if (isSelected) {
                Column(Modifier
                    .margin(top = 0.25.cssRem, bottom = 1.5.cssRem)
                    .padding(top = 0.5.cssRem, bottom = 0.5.cssRem)
                    .borderTop{
                        style(LineStyle.Solid)
                        color(aiPalette.mainPalette.darker)
                        width(2.px)
                    }
                    .borderBottom{
                        style(LineStyle.Solid)
                        color(aiPalette.mainPalette.darker)
                        width(2.px)
                    }) {
                    WorkingTogetherDescription(
                        WorkingTogetherContentMap.get(entrySelected.value) ?: WorkingTogetherData("NULL", "NULL", ""),
                        modifier = Modifier.width(100.percent)
                    )
                    WorkingTogetherImage(
                        entrySelected.value ?: "NULL",
                        modifier = Modifier.margin(top = 0.5.em).width(100.percent)
                    )
                }
            }
        }
    }
}


@Composable
fun WorkingTogetherDescription(entry: WorkingTogetherData, modifier: Modifier = Modifier) {
    Column(
        modifier = modifier
            .fontSize(0.8.cssRem)
            .fontWeight(FontWeight.Normal),
        horizontalAlignment = Alignment.Start
    )
    {
        Span(
            Modifier
                .textAlign(TextAlign.Justify)
                .whiteSpace(WhiteSpace.PreWrap).toAttrs()
        ) {
            Text(entry.details)
            Br()
        }
        Spacer()
        Span(
            Modifier
                .margin(top = 1.em)
                .fontSize(1.2.cssRem)
                .textAlign(TextAlign.Left)
                .whiteSpace(WhiteSpace.PreWrap).toAttrs()
        ) {
            AccTriangleIcon(Modifier.attr("fill", "white"))
            Text(entry.shortDescriptor)
        }
    }
}

@Composable
fun WorkingTogetherButton(
    modifier: Modifier = Modifier,
    entry: WorkingTogetherData,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    val borderColor = if (isSelected) {
        aiPalette.mainPalette.darker
    } else {
        aiPalette.mainPalette.darkest
    }
    Column(modifier = modifier)
    {
        Button(
            onClick = { evt ->
                evt.preventDefault()
                onClick()
            },
            modifier = Modifier
                .border {
                    color(borderColor)
                    style(LineStyle.Solid)
                    width(2.px)
                }
                .fontSize(0.85.em)
                .fillMaxWidth()
                .height(4.0.cssRem)
                .padding(topBottom = 0.em, leftRight = 2.em),
        ) {
            Column(
                Modifier.fillMaxHeight(),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.SpaceAround
            ) {
                Span() { Text(entry.title) }
            }
        }
        if (isSelected) {
            Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                ChevronDown2Icon(
                    Modifier
                        .width(4.em)
                        .height(2.em)
                        .styleModifier {
                            color(borderColor)
                        })
            }
        }
    }
}

@Composable
fun WorkingTogetherImage(fileName: String, modifier: Modifier = Modifier) {
    Div(
        modifier
            .borderRadius(6.px)
            .fillMaxHeight()
            .toAttrs()
    ) {
        Img(
            src = "assets/pics/worktogether/\\${fileName}.jpg",
            attrs = Modifier
                .width(100.percent)
                .height(100.percent)
                .objectFit(ObjectFit.Contain).toAttrs()
        )
    }
}

//
//@Composable
//fun WorkingTogetherText(selectedEntryState: MutableState<String>) {
//
//    Column(
//        Modifier
//            .margin(left=4.em),//width(max(40.vw, 720.px)),
//        verticalArrangement = Arrangement.Top,
//        horizontalAlignment = Alignment.Start
//    ) {
//        Row(
//            Modifier,
//            horizontalArrangement = Arrangement.Start,
//            verticalAlignment = Alignment.Top
//        ) {
//            var i = 0
//            for (entry in WorkingTogetherContentMap.entries) {
//                val isSelected = (entry.key == selectedEntryState.value)
//                Column(
//                    Modifier
//                        .padding(right = 1.em)
//                ) {
//                    val borderColor = if (isSelected) {
//                        aiPalette.mainPalette.darker
//                    } else {
//                        aiPalette.mainPalette.darkest
//                    }
//                    Button(
//                        onClick = { evt ->
//                            evt.preventDefault()
//                            selectedEntryState.value = entry.key
//                        },
//                        modifier = Modifier
//                            .border {
//                                color(borderColor)
//                                style(LineStyle.Solid)
//                                width(2.px)
//                            }
//                            .fontSize(0.85.em)
//                            .maxWidth(14.cssRem)
//                            .height(4.0.cssRem)
//                            .padding(topBottom = 0.em, leftRight = 2.em),
//                    ) {
//                        Column(
//                            Modifier.fillMaxHeight(),
//                            horizontalAlignment = Alignment.CenterHorizontally,
//                            verticalArrangement = Arrangement.SpaceAround
//                        ) {
//                            Span() { Text(entry.value.title) }
//                        }
//                    }
//                    if (isSelected) {
//                        Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
//                            ChevronDown2Icon(
//                                Modifier
//                                    .width(4.em)
//                                    .height(2.em)
//                                    .styleModifier {
//                                        color(borderColor)
//                                    })
//                        }
//                    }
//                }
//                i += 1
//            }
//        }
//        Column(
//            modifier = Modifier
//                .maxWidth(40.cssRem)
//                .padding(top = 1.em, leftRight = 2.em)
//                .fontSize(0.85.em)
//                .fontWeight(FontWeight.Normal)
//                .fillMaxHeight(),
//            horizontalAlignment = Alignment.CenterHorizontally
//        )
//        {
//            Span(
//                Modifier
//                    .textAlign(TextAlign.Justify)
//                    .whiteSpace(WhiteSpace.PreWrap).toAttrs()
//            ) {
//                Text(WorkingTogetherContentMap[selectedEntryState.value]?.details ?: "NULL")
//                Br()
//            }
//            Spacer()
//            Span(
//                Modifier
//                    .margin(top=1.em)
//                    .fontSize(1.2.cssRem)
//                    .textAlign(TextAlign.Justify)
//                    .whiteSpace(WhiteSpace.PreWrap).toAttrs()){
//                AccTriangleIcon(Modifier.attr("fill","white"))
//                Text(WorkingTogetherContentMap[selectedEntryState.value]?.shortDescriptor ?: "NULL")
//            }
//        }
//    }
//}